import type { CustomFieldTypeDefinition } from './customField.types';

/** Ordered definitions for admin configuration UI (dropdown + table labels). */
/** i18n keys shared by visitor custom field UIs (e.g. invite modal field-type column). */
const VISITOR_CUSTOM_FIELD_TYPE_DEFINITIONS: readonly CustomFieldTypeDefinition[] = [
  {
    value: 'text',
    labelKey: 'web.admin.content.features.visitor.management.general.customFields.fieldTypeValue.text',
  },
  {
    value: 'textarea',
    labelKey: 'web.admin.content.features.visitor.management.general.customFields.fieldTypeValue.textarea',
  },
  {
    value: 'select_dd',
    labelKey: 'web.admin.content.features.visitor.management.general.customFields.fieldTypeValue.select_dd',
  },
  {
    value: 'select_radio',
    labelKey: 'web.admin.content.features.visitor.management.general.customFields.fieldTypeValue.select_radio',
  },
  {
    value: 'multi_select',
    labelKey: 'web.admin.content.features.visitor.management.general.customFields.fieldTypeValue.multi_select',
  },
];

export function getVisitorCustomFieldTypeLabelKey(fieldType: string): string | undefined {
  const normalized = fieldType.toLowerCase();

  return VISITOR_CUSTOM_FIELD_TYPE_DEFINITIONS.find(d => d.value === normalized)?.labelKey;
}
